import { render, staticRenderFns } from "./feedback-count.vue?vue&type=template&id=90cbc304&"
import script from "./feedback-count.vue?vue&type=script&lang=js&"
export * from "./feedback-count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports